import {
  FaUsers,
  FaCalendarAlt,
  FaGamepad,
  FaChalkboardTeacher,
  FaChild,
  FaPaintBrush,
} from 'react-icons/fa';

const CATEGORY_LABELS = {
  MAGIC: 'Tornei e serate di gioco',
  NATURA: 'Eventi famiglia e territorio',
  ARTE: 'Laboratori creativi e culturali',
  EDUCATIV: 'Laboratori ed educazione',
  LABORATORIO: 'Laboratori creativi ed educativi',
  GENERAL: 'Attività per la community',
  BAMBINI: 'Eventi per ragazzi e famiglie',
  SCUOLA: 'Progetti scuole e territorio',
};

const formatCount = (n) => {
  const num = Number(n) || 0;
  return num.toLocaleString('it-IT');
};

const formatCategoryLabel = (category) => {
  const key = String(category || 'GENERAL').toUpperCase();
  return CATEGORY_LABELS[key] || category || 'Altre attività';
};

/**
 * Costruisce il modello UI per la sezione impatto sponsor dai dati /api/statistics?period=12m
 */
export const buildCommunityImpactFromStats = (stats, cilColors) => {
  const totalMembers = stats?.totalMembers || 0;
  const minorsCount = stats?.minorsCount || 0;
  const adultsCount = stats?.adultsCount || 0;
  const minorsPercent =
    totalMembers > 0 ? Math.round((minorsCount / totalMembers) * 100) : 0;
  const adultsPercent =
    totalMembers > 0 ? Math.round((adultsCount / totalMembers) * 100) : 0;

  const avg =
    stats?.avgParticipantsPerEvent > 0 ? stats.avgParticipantsPerEvent : null;

  const reach =
    avg != null
      ? `Ogni evento coinvolge in media circa ${avg} partecipanti: il tuo brand può raggiungere un pubblico fedele, locale e partecipativo.`
      : 'Il tuo brand può essere visibile a un pubblico fedele, locale e partecipativo nelle nostre attività.';

  const activityTypes = (stats?.eventsByCategory || [])
    .slice(0, 4)
    .map((row) => ({
      label: formatCategoryLabel(row.category),
      count: String(row.count),
    }));

  return {
    period: stats?.periodLabel || 'Ultimi 12 mesi',
    intro:
      'Sponsorizzare CIL significa raggiungere una community reale: famiglie, ragazzi e adulti che partecipano alle nostre attività a Chieri e in provincia. I dati sotto riassumono gli ultimi 12 mesi.',
    kpis: [
      {
        icon: FaUsers,
        value: formatCount(stats?.totalMembers),
        label: 'Soci tesserati',
        detail: 'Soci unici con tesseramento pagato negli ultimi 12 mesi',
        color: cilColors.yellow,
      },
      {
        icon: FaCalendarAlt,
        value: formatCount(stats?.totalEvents),
        label: 'Eventi organizzati',
        detail: 'Iniziative con data di svolgimento negli ultimi 12 mesi',
        color: cilColors.sky,
      },
      {
        icon: FaGamepad,
        value: formatCount(stats?.totalParticipations),
        label: 'Partecipazioni',
        detail: 'Iscrizioni confermate agli eventi negli ultimi 12 mesi',
        color: cilColors.teal,
      },
      {
        icon: FaChalkboardTeacher,
        value: formatCount(stats?.workshopsCount),
        label: 'Laboratori e corsi',
        detail: 'Eventi in categoria laboratorio / formativa',
        color: cilColors.pink,
      },
      {
        icon: FaChild,
        value: totalMembers > 0 ? `${minorsPercent}%` : '—',
        label: 'Soci under 18',
        detail: `${formatCount(minorsCount)} soci minorenni su ${formatCount(totalMembers)} tesserati`,
        color: cilColors.teal,
      },
      {
        icon: FaPaintBrush,
        value: formatCount(stats?.sedeEventsCount),
        label: 'Eventi in sede',
        detail: 'Attività svolte presso lo spazio associativo a Chieri',
        color: cilColors.yellow,
      },
    ],
    sociComposition: [
      { label: 'Under 18', percent: minorsPercent, color: cilColors.teal },
      {
        label: 'Adulti (18+)',
        percent: adultsPercent,
        color: cilColors.yellow,
      },
    ],
    activityTypes:
      activityTypes.length > 0
        ? activityTypes
        : [
            {
              label: 'Attività in programma',
              count: formatCount(stats?.totalEvents),
            },
          ],
    reach,
  };
};

/** Payload serializzabile per il PDF riassuntivo */
export const communityImpactForPdf = (impact) => {
  if (!impact) return null;
  return {
    period: impact.period,
    intro: impact.intro,
    kpis: impact.kpis.map(({ value, label, detail }) => ({
      value,
      label,
      detail,
    })),
    sociComposition: impact.sociComposition,
    activityTypes: impact.activityTypes,
    reach: impact.reach,
  };
};
